var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SocialNavigation = void 0;
const react_1 = __importDefault(require("react"));
const core_1 = require("@wheelroom/core");
const navigation_segment_1 = require("../../navigation-segment/navigation-segment");
const get_nav_segments_1 = require("../get-nav-segments");
exports.SocialNavigation = (props) => {
    if (props.hideSocial) {
        return null;
    }
    const segments = get_nav_segments_1.getNavSegments(props.navigation, 'social');
    return (react_1.default.createElement(core_1.Flex, { is: 'div', wheel: props.wheel },
        react_1.default.createElement(navigation_segment_1.NavigationSegment, { headingElementName: "h3", hideActionHeading: true, hideActionIcon: false, hideSegmentAbstract: true, hideSegmentHeading: true, maxSegments: props.maxSegments, navigationSegment: segments, wheel: Object.assign(Object.assign({}, props.wheel), { style: props.wheel.style.segment }) })));
};
//# sourceMappingURL=social-navigation.js.map